import { useEffect } from "react";
import { AppLayout } from "@/components/layout/AppLayout";
import { IaChat } from "@/components/IaChat";
import { useDemoStore } from "@/store/useDemoStore";

export default function AuditorIa() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("auditor"), [setRole]);
  return (
    <AppLayout pageTitle="Asistente IA · Auditor" breadcrumb={["Auditor", "Asistente IA"]}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <IaChat role="auditor" />
      </div>
    </AppLayout>
  );
}
